module.exports = __webpack_public_path__ + "static/media/inmynewworldModal.7f541de2.jpg";